// extracted by mini-css-extract-plugin
export default {"latest-posts":"LatestPosts_latest-posts__2HyNi","title":"LatestPosts_title__RV42T"};